import * as React from "react";
import { ILookupDictionary } from "../../../../lookup/types/ILookupDictionary";
import { sortWeightSettingsFieldData, updateUsagePoolField } from "../../../../redux/reducers/RepertoireReducer";
import IRepertoireComponentDataItem from "../../../../redux/types/IRepertoireComponentDataItem";
import { ITabReduxItem } from "../../../../redux/types/ITabReduxItem";
import { ADD_NEW_ACTION, CHECKBOX_INPUT, COPY_ACTION, DROPDOWN_INPUT, POOL_SOURCES_KEY, POOL_WEIGHT_SETTINGS_KEY, READ_ONLY_INPUT, REMOVE_ACTION, TEXT_INPUT, TIME_INPUT, INTEGER_INPUT } from "../../../Consts";
import { IRepertoireStateKeys } from "../../../types/IRepertoireStateKeys";
import { IUsagePoolAllocationSettingsDataItems } from "../../../types/usageTypes/IUsagePoolAllocationSettingsDataItems";
import DataGridTable from "../../../components/dataGridTable/DataGridTable";
import { ITreeData } from "../../../types/ITreeData";
import { IUsagePoolDatesAndDimensions } from "../../../types/usageTypes/IUsagePoolDatesAndDimensions";
import { IUsagePoolWeightSettingsStateKeys } from "../../../types/usageTypes/IUsagePoolWeightSettings";
import { IUsagePoolStateKeys } from "../../../../redux/types/IUsagePoolState";
import { createCopyOfTableContents } from "../../../services/TableFunctions";
import { IResultsPerPage } from "../../../../redux/types/IResultsPerPage";
import { IActiveAccordion } from "../../../../redux/types/IActiveAccordion";

export interface IPoolMaintenanceWeightSettingsGridProps {
    weightSettingsGridViewData?: IRepertoireComponentDataItem;
    isReadonly: boolean;
    poolAllocationSettings: IUsagePoolAllocationSettingsDataItems;
    updateUsagePoolField: typeof updateUsagePoolField;
    activeTab?: number;
    tabs?: ITabReduxItem[];
    lookupSources: ITreeData[];
    incrementTempID?: () => void;
    lookupValues: ILookupDictionary;
    tableContents: any;
    changeData?: (value: any, name: IRepertoireStateKeys, objectKey?: string, ipRepresentationsIdsToRemove?: number[]) => void;
    componentInstance: string;
    dataGridTableData: IRepertoireComponentDataItem;
    stateKey: IRepertoireStateKeys;
    poolEnabled?: boolean;
    datesAndDimensions?: IUsagePoolDatesAndDimensions[];
    sortWeightSettingsFieldData: typeof sortWeightSettingsFieldData;
    isBulkCheckboxActive?: boolean;
    changeBulkCheckbox?: (value: boolean) => void;
    allResultsPerPage?: IResultsPerPage[];
    updateUserPreferences?: (allResultsPerPage: IResultsPerPage[], activeAccordions: IActiveAccordion[], newActiveAccordionName?: string, accordionExpanded?: boolean, componentName?: string, indexOfFirstResult?: number, indexOfLastResult?: number, resultsPerPage?: number, repertoireSection?: string) => void;
}

export interface IIPoolMaintenanceWeightSettingsGridState {
    loaded: boolean;
    activeHeaderSection: string;
    currentPage: number;
    resultsPerPage: number;
}

export default class PoolMaintenanceWeightSettingsGrid extends React.Component<IPoolMaintenanceWeightSettingsGridProps, IIPoolMaintenanceWeightSettingsGridState> {
    viewData;
    constructor(props: IPoolMaintenanceWeightSettingsGridProps) {
        super(props);

        this.state = {
            loaded: false,
            activeHeaderSection: POOL_SOURCES_KEY,
            currentPage: 1,
            resultsPerPage: 50
        };
        this.viewData = {};
    }

    componentDidMount() {
        const {
            weightSettingsGridViewData: { fields }
        } = this.props;

        if (fields) {
            const visibleFields = fields.filter(field => !field.hidden);
            visibleFields.forEach(item => {
                this.viewData[item.name] = item.data;

                if (Object.keys(this.viewData).length === visibleFields.length) {
                    this.setState({ loaded: true });
                }
            });
        }
    }

    changeData = (value: any, name: IRepertoireStateKeys) => {
        const { updateUsagePoolField } = this.props;
        updateUsagePoolField(value, name as IUsagePoolStateKeys);
    }

    sortData(value: any, name: IRepertoireStateKeys): void {
        this.props.sortWeightSettingsFieldData(value, name as IUsagePoolWeightSettingsStateKeys);
    }

    updateInputTypesFromDatesAndDimensions = () => {
        const { tableContents, datesAndDimensions } = this.props;

        return tableContents.map((row) => {
            const match = datesAndDimensions.find(
                (dim) => dim.effectiveDateRange === row.effectiveDateRange.value
            );
			
            if (!match) return row; // no update
			
            return {
                ...row,
                use: {
                    ...row.use,
                    inputType: match.use ? TEXT_INPUT : READ_ONLY_INPUT,
                },
                usageDimensionOne: {
                    ...row.usageDimensionOne,
                    inputType: match.dimension1 ? TEXT_INPUT : READ_ONLY_INPUT,
                },
                usageDimensionTwo: {
                    ...row.usageDimensionTwo,
                    inputType: match.dimension2 ? TEXT_INPUT : READ_ONLY_INPUT,
                },
                usageDimensionThree: {
                    ...row.usageDimensionThree,
                    inputType: match.dimension3 ? TEXT_INPUT : READ_ONLY_INPUT,
                },
                usageDimensionFour: {
                    ...row.usageDimensionFour,
                    inputType: match.dimension4 ? TEXT_INPUT : READ_ONLY_INPUT,
                },
                usageDimensionFive: {
                    ...row.usageDimensionFive,
                    inputType: match.dimension5 ? TEXT_INPUT : READ_ONLY_INPUT,
                },
                fromTime: {
                    ...row.fromTime,
                    inputType: match.time ? TIME_INPUT : READ_ONLY_INPUT,
                },
                toTime: {
                    ...row.toTime,
                    inputType: match.time ? TIME_INPUT : READ_ONLY_INPUT,
                },
                musicSource: {
                    ...row.musicSource,
                    inputType: match.musicSource ? TEXT_INPUT : READ_ONLY_INPUT,
                },
            };
        });
    };    

    getNewItem = () => {
        return {
            weightingCode: { value: "", inputType: TEXT_INPUT },
            musicSource: { value: "", inputType: TEXT_INPUT },
            use: { value: "", inputType: TEXT_INPUT },
            effectiveDateRange: { value: "", inputType: DROPDOWN_INPUT },
            fromTime: { value: "", inputType: TIME_INPUT },
            toTime: { value: "", inputType: TIME_INPUT },
            usageDimensionOne: { value: "", inputType: TEXT_INPUT },
            usageDimensionTwo: { value: "", inputType: TEXT_INPUT },
            usageDimensionThree: { value: "", inputType: TEXT_INPUT },
            usageDimensionFour: { value: "", inputType: TEXT_INPUT },
            usageDimensionFive: { value: "", inputType: TEXT_INPUT },
            weightMultiplier: { value: "", inputType: INTEGER_INPUT },
            copySection: { value: false, inputType: CHECKBOX_INPUT },
        }
    }

    handleAdd = () => {
        const { incrementTempID, tableContents } = this.props;
        const newItem = this.getNewItem();
        incrementTempID();
        this.changeData([...tableContents, newItem], POOL_WEIGHT_SETTINGS_KEY as IUsagePoolStateKeys);
    }

    handleCopy = () => {
        const { tableContents, incrementTempID, datesAndDimensions, updateUsagePoolField } = this.props;
        const allRowsToBeCopied = tableContents.filter(row => {
            return row && row?.copySection?.value
        })

        let tableContentsCopy: any = tableContents ? createCopyOfTableContents(tableContents) : [];
        let newItems = [];
        allRowsToBeCopied.forEach(row => {
            const result = row?.effectiveDateRange?.value && datesAndDimensions.filter((word) => word.effectiveDateRange === row.effectiveDateRange.value);
            newItems.push({
                weightingCode: { value: row.weightingCode.value, inputType: TEXT_INPUT },
                musicSource: { value: row.musicSource.value, inputType: result && result[0] && result[0]?.musicSource ? TEXT_INPUT : READ_ONLY_INPUT },
                usageDimensionOne: { value: row.usageDimensionOne.value, inputType: result && result[0] && result[0]?.dimension1 ? TEXT_INPUT : READ_ONLY_INPUT },
                usageDimensionTwo: { value: row.usageDimensionTwo.value, inputType: result && result[0] && result[0]?.dimension2 ? TEXT_INPUT : READ_ONLY_INPUT },
                usageDimensionThree: { value: row.usageDimensionThree.value, inputType: result && result[0] && result[0]?.dimension3 ? TEXT_INPUT : READ_ONLY_INPUT },
                usageDimensionFour: { value: row.usageDimensionFour.value, inputType: result && result[0] && result[0]?.dimension4 ? TEXT_INPUT : READ_ONLY_INPUT },
                usageDimensionFive: { value: row.usageDimensionFive.value, inputType: result && result[0] && result[0]?.dimension5 ? TEXT_INPUT : READ_ONLY_INPUT },
                use: { value: row.use.value, inputType: TEXT_INPUT },
                effectiveDateRange: { value: row.effectiveDateRange.value, inputType: DROPDOWN_INPUT },
                fromTime: { value: row.fromTime.value, inputType: TIME_INPUT },
                toTime: { value: row.toTime.value, inputType: TIME_INPUT },
                weightMultiplier: { value: row.weightMultiplier.value, inputType: INTEGER_INPUT },
                copySection: { value: false, inputType: CHECKBOX_INPUT },
                dimensionsAndDatesID: row.dimensionsAndDatesID,
                poolID: row.poolID,
            });
        });

        if (newItems.length > 0) {
            newItems.forEach(item => {
                tableContentsCopy.push(item);
            })
        }

        updateUsagePoolField(tableContentsCopy, POOL_WEIGHT_SETTINGS_KEY);
        incrementTempID();
    }

    render() {
        if (!this.state.loaded)
            return null;

        const { 
            lookupSources,
            incrementTempID,
            isBulkCheckboxActive,
            changeBulkCheckbox,
            lookupValues, 
            dataGridTableData,
            datesAndDimensions,
            tabs,
            activeTab,
            poolEnabled,
            stateKey,
            allResultsPerPage,
            updateUserPreferences
        } = this.props;

        const tableContentsUpdated = this.updateInputTypesFromDatesAndDimensions();

        const hasValidEffectiveDateRange = !!datesAndDimensions?.some(
          (d) =>
            d?.effectiveDateRange !== null &&
            d?.effectiveDateRange !== undefined &&
            String(d.effectiveDateRange).trim().length > 0,
        );

        return (
            <div tabIndex={0}>
                <DataGridTable
                    customComponentOnClickAdd={this.handleAdd}
                    tableContents={tableContentsUpdated}
                    changeData={this.changeData.bind(this)}
                    dataGridTableData={dataGridTableData}
                    stateKey={stateKey}
                    componentInstance={POOL_WEIGHT_SETTINGS_KEY}
                    showRowNumber={true}
                    isReadOnly={!poolEnabled}
                    tableActions={[{ name: ADD_NEW_ACTION, disabled: !hasValidEffectiveDateRange }, { name: REMOVE_ACTION }, { name: REMOVE_ACTION }, { name: COPY_ACTION }]}
                    lookupValues={lookupValues}
                    lookupSources={lookupSources}
                    tabs={tabs}
                    activeTab={activeTab}
                    incrementTempID={incrementTempID}
                    datesAndDimensions={datesAndDimensions}
                    sortData={this.sortData.bind(this)}
                    allowMultiSelectChbk={true}
                    isBulkCheckboxActive={isBulkCheckboxActive}
                    changeBulkCheckbox={changeBulkCheckbox}
                    onClickCopy={this.handleCopy}
                    isRowSelectionEnabled
                    resultsPerPage={this.state.resultsPerPage}
                    currentPage={this.state.currentPage}
                    allResultsPerPage={allResultsPerPage}
                    updateUserPreferences={updateUserPreferences}
                />
            </div>
        )
    }
}